import { Button, message, Statistic } from 'antd';
import React, { useEffect, useState } from 'react';
// import NumberFormat from 'react-number-format';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import { useGlobalState } from '../../../../store/state';
import './CampQuickViewComponent.styles.scss';
import { CampaignCalculator } from '../../../../apis/Brand/Campaigns/CampaignCalculator';
import { checkObjectKeyValues } from '../../../../utils';
import moment from 'moment';
import { SyncCampiagnData } from '../../../../utils/SyncCampiagnData';
import { IoSaveOutline } from 'react-icons/io5';

const CampQuickViewComponent = ({ onSaveDraft }) => {
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [campDefSet] = useGlobalState('campDefSet');
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  const [calcData, setCalcData] = useState({});
  const {
    platform,
    objective,
    budget,
    deliverables,
    startdate,
    enddate,
  } = create_camp_draft;
  // @note: calculate campaign budget
  useEffect(() => {
    SyncCampiagnData(
      create_camp_draft, // store sync object
      company.selected.id, // active company id
      campDefSet, // default field set for pre filter
      {
        campaignid: create_camp_draft.campaignid,
        data: checkObjectKeyValues(create_camp_draft), // prepared data or existing data
        returnOnly: true, // this option used to get data back only instead of sync in store
      }, // updated set of data to process
    ).then((data)=>{
      // @note: preparing data to calculate
      const _data = {
        ...data, // all existing data
        startdate: moment(data.startdate).valueOf(), // converting startdate to milliseconds
        enddate: moment(data.enddate).valueOf(), // converting enddate to milliseconds
      };
      CampaignCalculator(user.accessToken, checkObjectKeyValues(_data)).then(({ status, response })=>{
        // console.log("calulated",response)
        if (status === 200) {
          setCalcData({
            ...calcData,
            ...response,
          });
        } else {
          console.log('calulator error', response);
          // message.error("There some issue while calulating")
        }
      });
    });
  }, [create_camp_draft]);

  const getCampDays = () =>{
    const _e = moment(enddate);
    const _s = moment(startdate);
    const _ms = _e.diff(_s, 'days');
    return _ms;
  };

  return (
    <div className="camp_quickview p-3">
      <h5 className="camp_quickview--title">Quick Review</h5>
      <div className="row justify-content-between">
        <div className="col-auto">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Platform</div>
            <div className="camp_quickview_each--value">{platform || 'N/A'}</div>
          </div>
        </div>
        <div className="col-auto text-center">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Objective</div>
            <div className="camp_quickview_each--value">{objective || 'N/A'}</div>
          </div>
        </div>
        <div className="col-auto text-right">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Budget</div>
            <div className="camp_quickview_each--value"><CurrencyIcon size={15}
              color="#999"/>
            {
              budget ?
                <Statistic className="custom_number_format"
                  value={budget}
                  precision={2}/> :
              // <NumberFormat value={budget} thousandSeparator={true} thousandsGroupStyle="lakh" displayType={'text'}/>
                'N/A'
            }
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Influencer Reach</div>
            <div className="camp_quickview_each--value">{calcData.influencers || 'N/A'}</div>
          </div>
        </div>
        <div className="col-auto text-right">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">No. of days</div>
            <div className="camp_quickview_each--value">{getCampDays() || 'N/A'}</div>
          </div>
        </div>
        <div className="col-6">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Total Creatives</div>
            <div className="camp_quickview_each--value">{deliverables.length || 'N/A'}</div>
          </div>
        </div>
        <div className="col-auto text-right">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Creative Types</div>
            <div className="camp_quickview_each--value">2</div>
          </div>
        </div>
        <div className="col-6">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Est. Execution Budget</div>
            <div className="camp_quickview_each--value big"><CurrencyIcon color="#999"/>{
              budget ?
                <Statistic className="custom_number_format"
                  value={budget}
                  precision={2}/> :
              // <NumberFormat value={budget} thousandSeparator={true} thousandsGroupStyle="lakh" displayType={'text'}/>
                'N/A'
            }</div>
          </div>
        </div>
        <div className="col-6 text-right">
          <div className="camp_quickview_each">
            <div className="camp_quickview_each--label">Avg. Engagement Rate</div>
            <div className="camp_quickview_each--value big">{calcData.avgEngagementRate + '%' || 'N/A'}</div>
          </div>
        </div>
        <div className="col-12 text-right pt-3">
          <Button className="common_button outlined py-2"
            onClick={onSaveDraft}><IoSaveOutline size={16}
              className="mr-2"/>Save Draft</Button>
        </div>
      </div>
    </div>
  );
};

export default CampQuickViewComponent;
